import HSBB from './hsbb-sdk';
import { getToken } from './utility';

const baseURL = process.env.REACT_APP_API_URL;

const HSBBClient = new HSBB({ baseURL, getToken });

export default HSBBClient;
